import React from "react";
import { useState, useEffect } from "react";
import 'aos/dist/aos.css';
import { toast } from "react-toastify";
import axios from 'axios';
import Footer from "../../components/footer";
import background from '../../assets/background.png';
import logo from '../../assets/logo.png';
import title from '../../assets/tittle.png';
import titleMB from '../../assets/tittleMB.png';
import rule from '../../assets/rule.png';
import ruleMobile from '../../assets/ruleMobile.png';
import PromotionModal1 from '../../components/promotionModal1';
import ListPromotionModal from '../../components/listPromotionModal';
import styles from './style.module.css'; 
import Loader from '../../components/loading';
import LoadingApply from '../../components/loadingApply';
import CryptoJS from "crypto-js";
import FingerprintJS from "@fingerprintjs/fingerprintjs-pro";


const HomePage = () => {
    const [activeButton, setActiveButton] = useState('promotions');
    const [username, setUsername] = useState("");
    const [captcha, setCaptcha] = useState("");
    const [captchaId, setCaptchaId] = useState("");
    const [captchaSvg, setCaptchaSvg] = useState("");
    const [promotions, setPromotions] = useState(null);
    const [listPromotions, setListPromotions] = useState(null);
    const [promotionsMB, setPromotionsMB] = useState(null);
    const [promotion, setPromotion] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [openListPromotionModal, setOpenListPromotionModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingApply, setLoadingApply] = useState(false);
    const [visibleCount, setVisibleCount] = useState(4);
    const [loadedImages, setLoadedImages] = useState({})
    const [showForbiddenModal, setShowForbiddenModal] = useState(false);

    const secretKey = 'RR882024RR88';
    useEffect(() => {
        fetchCaptcha();
        fetchPromotionMB();
        fetchPromotion();
        setLoading(true)
      }, []);
      const fetchCaptcha = async () => {
        try {
            // const fp = await FingerprintJS.load();
            // const result = await fp.get();

            // const fingerprint = result.visitorId;
        
            const response = await fetch(`${process.env.REACT_APP_API_URL}/captcha`, {
              method: 'GET', 
              headers: {
                'Content-Type': 'application/json',
              },
            });
            const data = await response.json();
        
            if (data.statusCode === 200) {
              setCaptchaId(data.data.captchaId);
              setCaptchaSvg(data.data.captcha);
            } else {
              toast.error("Không thể tải Captcha");
            }
          } catch (error) {
            toast.error("Lỗi tải Captcha");
          }
    };
    
    const encryptData = (data) => {
        return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
      };

    const fetchPromotion = async () => {
        setLoading(true);
        const loadingTimeout = setTimeout(() => setLoading(false), 3000);

        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/promotion`);
            setPromotions(response.data.data.promotion);
            setLoading(false);
            clearTimeout(loadingTimeout);
        } catch (error) {
            console.error('Error:', error);
        }
    };
    
    const fetchPromotionMB = async () => {
        const loadingTimeout = setTimeout(() => setLoading(false), 3000);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/promotion?platform=M`);
            setPromotionsMB(response.data.data.promotion);
            setLoading(false);
            clearTimeout(loadingTimeout);
        } catch (error) {
            console.error('Error:', error);
        }
    };
    
    const checkUsername = async () => {
        if (!username.trim() || !captcha.trim()) {
            toast.warn("Vui lòng nhập đầy đủ thông tin!");
            return;
        }
        try {
            setLoadingApply(true);
            const fingerprint = sessionStorage.getItem("fp");
    
            // Mã hóa payload
            const encryptedPayload = encryptData({
                username: username.toLowerCase(),
                captcha,
                captchaId,
            });
    
            const response = await fetch(`${process.env.REACT_APP_API_URL}/promotion/check`, {
                method: "POST", 
                headers: {
                    "Content-Type": "application/json",
                    "X-Fingerprint": fingerprint, 
                },
                body: JSON.stringify({ data: encryptedPayload }), // Gửi payload đã mã hóa
            });
    
            const data = await response.json();
            if (data.statusCode === 200) {
                setOpenListPromotionModal(true);
                setListPromotions(data.data.promotions);
            } else if (data.statusCode === 403) {
                setShowForbiddenModal(true); // Mở modal cảnh báo
            } else {
                toast.error(data?.message || "Có lỗi xảy ra!");
            }
            fetchCaptcha();
            setLoadingApply(false);
        } catch (error) {
            toast.error("Có lỗi xảy ra, vui lòng thử lại!");
        }
    };

    const clickPromotion = (promotion) => {
        setPromotion(promotion);
        setOpenModal(true);
    };

    const closeModal = () => {
        setOpenModal(false);
    };

    const closeListPromotionModal = () => {
        setOpenListPromotionModal(false);
    };

    const loadMore = () => {
        setVisibleCount((prev) => prev + 99); 
      };

      const handleImageLoad = (id) => {
        setLoadedImages((prev) => ({ ...prev, [id]: true }));
      };

    return (
        <>
            {loading && <Loader />}
            {loadingApply && <LoadingApply/>}
            <div className="bg-white min-h-screen flex flex-col md:block hidden">
            <div 
                className="p-4 flex flex-col items-center justify-between bg-cover bg-center " 
                style={{
                    backgroundImage: `linear-gradient(rgba(18, 76, 184, 0.5), rgba(59, 132, 201, 0.5)), url(${background})`
                }}
            >
                <div className="relative w-full flex flex-col items-center p-0">
                <button
                    onClick={() => {
                        if (window.history.length > 1) {
                            const previousUrl = document.referrer;
                            if (previousUrl.includes('rr')) {
                                window.history.back();
                            } else {
                                window.location.href = "https://rr311.com";
                            }
                        } else {
                            window.location.href = "https://rr311.com";
                        }
                    }}
                    className="absolute top-4 left-4 px-4 py-2 rounded-lg text-white transition-all duration-300 hover:scale-105"
                >
                    ⬅ VỀ TRANG CHỦ
                </button>
                </div>
                    <img 
                        src={logo} 
                        alt="Logo" 
                        className={`${styles.logo} ${styles.fadeIn}`} 
                        />
                    <div className="w-16">
                    </div> 
                    {/* Hình ảnh tiêu đề */}
                    <div className="flex-grow flex flex-col items-center text-gray-700 bg-opacity-75 pt-10">
                        <img src={title} alt="Tittle" className="w-auto max-h-40 max-w-full mb-4" />
                    </div>
                    <div className="bg-[#F5F9FF] p-4 flex gap-6 max-w-5xl rounded-lg mt-10">
                        <input
                            type="text"
                            placeholder="Vui lòng nhập TÊN TÀI KHOẢN"
                            className="w-72 p-4 rounded-lg border border-gray-400 outline-none"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                        <div className="relative w-80 flex ">
                            <input
                                type="text"
                                placeholder="Nhập mã CAPTCHA"
                                className="p-4 rounded-lg border border-gray-400 outline-none w-full pr-12"
                                value={captcha}
                                onChange={(e) => setCaptcha(e.target.value)}
                            />
                            {captchaSvg && (
                                <div
                                    className="absolute right-[2px] top-[3px] cursor-pointer pl-1 "
                                    dangerouslySetInnerHTML={{ __html: captchaSvg }}
                                    onClick={fetchCaptcha} 
                                />
                            )}
                        </div>
                        <button
                        className="w-64 p-4 rounded-lg border border-gray-400 flex items-center justify-center text-white font-medium bg-gradient-to-b from-[#61F1FB] to-[#2063FC] hover:opacity-80 transition-all"
                        onClick={checkUsername}
                        >
                            Xác nhận
                        </button>
                    </div>
                </div>
                <div className="w-full flex flex-col items-center p-4 bg-gray-100">
                    {/* Khối input và button */}
                    <div className="p4 flex gap-4 rounded-full mt-8">
                        <button
                            className={`w-48 p-3 rounded-full border border-gray-400 flex items-center justify-center ${activeButton === 'promotions' ? 'text-white font-medium bg-gradient-to-b from-[#61F1FB] to-[#2063FC]' : 'text-black font-medium bg-white hover:opacity-80'}`}
                            onClick={() => setActiveButton('promotions')}
                        >
                            Khuyến mãi hot
                        </button>
                        <button
                            className={`w-48 p-3 rounded-full border border-gray-400 flex items-center justify-center  ${activeButton === 'conditions' ? 'text-white font-medium bg-gradient-to-b from-[#61F1FB] to-[#2063FC]' : 'text-black font-medium bg-white hover:opacity-80'}`}
                            onClick={() => setActiveButton('conditions')} 
                        >
                            Quy tắc và điều kiện
                        </button>
                    </div>
                    {activeButton === "promotions" ? (
                    <>
                        {/* Danh sách ảnh */}
                        <div className="grid grid-cols-2 gap-4 mt-8">
                        {promotions?.slice(0, visibleCount).map((promotion) => (
                            <div key={promotion.id} className="w-full p-2 relative">
                            {/* Chỉ hiển thị skeleton loader cho ảnh chưa load */}
                            {!loadedImages[promotion.id] && (
                                <div className="w-full h-48 bg-gray-300 animate-pulse rounded-lg"></div>
                            )}

                            {/* Ảnh */}
                            <img
                                src={promotion?.announcementImages?.[0]?.url || ""}
                                alt={`img-${promotion.id}`}
                                className={`w-full h-auto object-cover cursor-pointer transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-lg rounded-lg ${
                                loadedImages[promotion.id] ? "block" : "hidden"
                                }`}
                                loading="lazy"
                                onLoad={() => handleImageLoad(promotion.id)}
                                onClick={() => clickPromotion(promotion)}
                            />
                            </div>
                        ))}
                        </div>

                        {/* Nút Xem thêm */}
                        {promotions?.length > visibleCount && (
                        <div className="text-center mt-4">
                            <button
                            onClick={loadMore}
                            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                            >
                            Xem thêm
                            </button>
                        </div>
                        )}
                    </>
                    ) : (
                        <div className="mt-12">
                            <img src={rule} alt="Rule" className="w-auto h-auto max-w-full mb-4" />
                        </div>
                    )}
                </div>
            </div>
        {/* Mobile */}

            <div className="bg-gray-200 min-h-screen flex flex-col items-center md:hidden block">
            {/* Header */}
            <div 
                className="p-4 flex flex-col items-center justify-between bg-cover bg-center " 
                style={{
                    backgroundImage: `linear-gradient(rgba(18, 76, 184, 0.5), rgba(59, 132, 201, 0.5)), url(${background})`
                }}
            >
                <div className="w-full flex flex-col items-center justify-center ">
                <button
                    onClick={() => {
                        if (window.history.length > 1) {
                            const previousUrl = document.referrer;
                            if (previousUrl.includes('rr')) {
                                window.history.back();
                            } else {
                                window.location.href = "https://rr311.com";
                            }
                        } else {
                            window.location.href = "https://rr311.com";
                        }
                    }}
                    className="text-white rounded-lg"
                >
                    ⬅ Về trang chủ
                </button>
                    <img src={logo} alt="Logo" className={`${styles.logo} ${styles.fadeIn}`} />
                    <div className="w-12"></div> {/* Khoảng trống, nếu không cần thì có thể bỏ */}
                </div>

                {/* Tiêu đề */}
                <div className="w-full flex flex-col items-center text-gray-700 mt-6">
                    <img src={titleMB} alt="Title" className="w-9/10 max-h-40" />
                </div>

                {/* Input và Button */}
                <div className="bg-[#F5F9FF] p-4 flex flex-col gap-3 w-full max-w-md rounded-lg mt-6">
                    <input
                    type="text"
                    placeholder="Nhập tài khoản"
                    className="p-3 rounded-lg border border-gray-400 outline-none w-full"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    />
                    <div className="relative flex ">
                        <input
                            type="text"
                            placeholder="Nhập mã CAPTCHA"
                            className="p-4 rounded-lg border border-gray-400 outline-none w-full pr-12"
                            value={captcha}
                            onChange={(e) => setCaptcha(e.target.value)}
                            />
                        {captchaSvg && (
                            <div
                                className="absolute right-[2px] top-[3px] cursor-pointer pl-1 "
                                dangerouslySetInnerHTML={{ __html: captchaSvg }}
                                onClick={fetchCaptcha} 
                                />
                            )}
                            </div>
                    <button className="p-3 rounded-lg bg-gradient-to-b from-[#61F1FB] to-[#2063FC] text-white" onClick={checkUsername}> 
                    Xác nhận
                    </button>
                </div>
            </div>
            <div>
                {/* Tabs */}
                <div className="flex gap-2 w-full max-w-md mt-6 text-xs px-4">
                    <button
                    className={`w-1/2 p-3 rounded-full border border-gray-400 ${
                        activeButton === "promotions"
                        ? "text-white bg-gradient-to-b from-[#61F1FB] to-[#2063FC]"
                        : "text-black bg-white"
                    }`}
                    onClick={() => setActiveButton("promotions")}
                    >
                    Khuyến mãi hot
                    </button>
                    <button
                    className={`w-1/2 p-3 rounded-full border border-gray-400 ${
                        activeButton === "conditions"
                        ? "text-white bg-gradient-to-b from-[#61F1FB] to-[#2063FC]"
                        : "text-black bg-white"
                    }`}
                    onClick={() => setActiveButton("conditions")}
                    >
                    Quy tắc và điều kiện
                    </button>
                </div>

                {/* Nội dung */}
                {activeButton === "promotions" ? (
                    <>
                    {/* Danh sách ảnh */}
                    <div className="flex flex-col gap-2 mt-4 w-full max-w-md">
                    {promotionsMB?.slice(0, visibleCount).map((promotion) => (
                        <div key={promotion.id} className="w-full p-2">
                            <img
                            src={promotion.announcementImages[0].url}
                            alt={`img-${promotion.id}`}
                            className="w-full h-auto object-cover cursor-pointer transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-lg"
                            onClick={() => clickPromotion(promotion)}
                            />
                        </div>
                        ))}
                    </div>

                {/* Nút Xem thêm */}
                {promotionsMB?.length > visibleCount && (
                    <div className="text-center mt-4">
                    <button
                        onClick={loadMore}
                        className="mb-4 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                    >
                        Xem thêm
                    </button>
                    </div>
                )}
                </>
                ) : (
                    <div className="mt-6 mb-4">
                    <img src={ruleMobile} alt="RuleMobile" className="w-auto h-auto max-w-full" />
                    </div>
                )}
                </div>
            </div>
            <Footer></Footer>
            <PromotionModal1 isOpen={openModal === true} onClose={closeModal} promotion={promotion}/>
            <ListPromotionModal isOpen={openListPromotionModal === true} onClose={closeListPromotionModal} promotions = {listPromotions} username={username}/>
            {showForbiddenModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white rounded-lg shadow-lg p-6 w-11/12 sm:w-96">
                        <h2 className="text-lg font-bold text-red-600 text-center">
                            TÀI KHOẢN KHÔNG ĐƯỢC THAM GIA KHUYẾN MÃI
                        </h2>
                        <p className="text-sm text-gray-700 text-center mt-2">
                            Vui lòng liên hệ CSKH 24/7 để được hỗ trợ.
                        </p>
                        <div className="mt-4 text-center">
                            <a
                                href="https://cskhrr88.pages.dev"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 font-semibold hover:underline"
                            >
                                https://cskhrr88.pages.dev
                            </a>
                        </div>
                        <div className="mt-4 flex justify-center">
                            <button
                                onClick={() => setShowForbiddenModal(false)}
                                className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-lg"
                            >
                                Đóng
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default HomePage;
